import { render, staticRenderFns } from "./ModalSettingPlugin.vue?vue&type=template&id=0e56341e&scoped=true"
import script from "./ModalSettingPlugin.vue?vue&type=script&lang=js"
export * from "./ModalSettingPlugin.vue?vue&type=script&lang=js"
import style0 from "./ModalSettingPlugin.vue?vue&type=style&index=0&id=0e56341e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e56341e",
  null
  
)

export default component.exports